module.exports = __webpack_public_path__ + "img/wechat.63197f4b.png";